import {
  FormInventoryLot,
  InventoryLotApiParams,
  buildNewInventoryLot,
  InventoryLot,
  InventoryLotNumberKeys,
} from "@/models/InventoryLot";
import store, { StoreActions } from "@/store";
import { JSConn } from "@/utilities/js-conn";
import api from "@/api";
import { convertStringToNumber } from "@/utilities/controllerHelpers";

const itemDetails = {
  pluralName: "inventory_lots",
  singularName: "inventory_lot",
};

import { IlsctlNumberKeys } from "@/models/IlsctlLineItem";

const apiParamsBuilder = (jsConn: JSConn) => {
  const formParams = jsConn.formParams as FormInventoryLot;

  return {
    id: jsConn.formParams.id,
    inventory_lot: {
      ...formParams,
    } as InventoryLotApiParams,
  };
};

export const ilStringsToNumbers = (il: InventoryLot) => {
  const newIl = convertStringToNumber(InventoryLotNumberKeys, { ...il });
  const newLineItems = [...newIl.ilsctl_line_items];

  for (const ilsctl of newLineItems) {
    convertStringToNumber(IlsctlNumberKeys, ilsctl);
  }

  newIl.ilsctl_line_items = newLineItems;

  return newIl;
};

async function needInventoryLots(jsConn: JSConn) {
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    let tmpValue = [...jsConn.response];

    tmpValue = tmpValue.map(item => {
      return ilStringsToNumbers(item);
    });

    return store.dispatch(StoreActions.loadInventoryLots, tmpValue);
  });
}

async function needInventoryLot(jsConn: JSConn) {
  return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
    let tmpValue = { ...jsConn.response };
    tmpValue = ilStringsToNumbers(tmpValue);

    return store.dispatch(StoreActions.loadInventoryLot, tmpValue);
  });
}

async function createInventoryLot(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .createItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      let tmpValue = { ...jsConn.response };

      tmpValue = ilStringsToNumbers(tmpValue);
      return store.dispatch(StoreActions.loadInventoryLot, tmpValue);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function updateInventoryLot(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .updateItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      let tmpValue = { ...jsConn.response };

      tmpValue = ilStringsToNumbers(tmpValue);
      return store.dispatch(StoreActions.loadInventoryLot, tmpValue);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function deleteInventoryLot(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .deleteItem(jsConn, itemDetails)
    .then(jsConn => {
      store.dispatch(StoreActions.loadInventoryLot, buildNewInventoryLot());
      return Promise.resolve(jsConn);
    })
    .catch(jsConn => {
      return Promise.reject(jsConn);
    });
}

export const inventoryLotsController = {
  needInventoryLots,
  needInventoryLot,
  createInventoryLot,
  updateInventoryLot,
  deleteInventoryLot,
};
